import React from 'react';
import logo from '../../images/IE.png';
import './NotFound.css';

function NotFound() {
  return (
    <div id="not-found-container" className="d-flex justify-content-around align-items-center flex-column">
      <div id="ie-logo">
        <img src={logo} alt="IE Logo" />
      </div>
      <div className="text-center">
        <h1 className="blue">A página que você procura não existe...</h1>
        <h5 className="mt-3">Será que o endereço está digitado corretamente?</h5>
      </div>
    </div>
  );
}

export default NotFound;
